import ElementWatcher from '../helpers/sizing/element';
import ViewportWatcher from '../helpers/sizing/viewport';

export function initViewportWatcher() {
    // new ViewportWatcher('--window-height', true); // eslint-disable-line no-new
    new ViewportWatcher('--window-height-initial', false); // eslint-disable-line no-new
}

export function initElementWatcher() {
    const element = document.querySelector('.header');
    const target = document.querySelector('.main-container');
    
    if (element !== null && target !== null) {
        new ElementWatcher('--header-height', true, element, target); // eslint-disable-line no-new
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initViewportWatcher();
    initElementWatcher();
});